<template>
  <div>
    <hr :style="'border-top:'+currentField.maxheight+'px '+currentField.dividerType+' '+ currentField.color+';width:'+currentField.maxwidth+'%;'" class="custom-divider">
  </div>

</template>

<script>
export default {
  name: 'Divider',
  props: ['currentField'],
  data() {
    return {
      // input: ''
    };
  },
//   computed: {
//     attributesBinding() {
//       var attr = {};
//       if (this.currentField.showWordLimit) {
//         attr.maxlength = this.currentField.maxlength;
//         attr['show-word-limit'] = this.currentField.showWordLimit;
//       }

//       if (this.currentField.clearable) {
//         attr.clearable = this.currentField.clearable;
//       }

//       if (this.currentField.disabled) {
//         attr.disabled = this.currentField.disabled;
//       }

//       if (this.currentField.showPassword) {
//         attr['show-password'] = this.currentField.showPassword;
//       }

//       if (this.currentField.isPlaceholderVisible) {
//         attr.placeholder = this.currentField.placeholder;
//       }
//       // attr.componentValue = this.input;
//       return attr;
//     }
//   },
//   methods: {
//     textBoxChange(value) {
//       this.currentField.componentValue = value;
//     }
//   }
};
</script>
<style scoped>
.custom-divider{
  border-top: 3px solid rgb(228 228 228) !important;
  width: 50% !important;
  margin-top: 28px;
  margin-bottom: 28px;
}
</style>
